import {Component, inject, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RestClient} from '../../../../../Api/DcoApi/Client/RestClient';

@Component({
  selector: 'app-resubmit-code',
  imports: [
    CommonModule,
    FormsModule,
    FormsModule,
  ],
  templateUrl: './resubmit-code.html',
  styleUrl: './resubmit-code.css',
})
export class ResubmitCode {
  @Input() Key: number = 0;
  modal = inject(NgbActiveModal);
  Code: string = "";

  apiClinet: RestClient = new RestClient();

  async SenCode()
  {
    try
    {
      await this.apiClinet.Post<any,any>(`/Absetzung/${this.Key}/${this.Code}`, null);
      this.modal.close();
    }
    catch (error)
    {
      console.log(error);
    }

  }

}
